const isFavorite = (state, resourceId) => state.favoriteState.resources[resourceId];

export default {
  isFavorite
};
